<template>
    <FormInputContainer :inputId="`I${_uid}`" :label="label" :errors="errors" :required="required">
        <select :id="`I${_uid}`" v-bind="$attrs" :value="value" @input="$emit('input', $event.target.value)">
            <option value="" :hidden="!nullable"></option>
            <slot></slot>
        </select>
    </FormInputContainer>
</template>


<script>
import FormInputContainer from './FormInputContainer';

export default {
    name: 'FormSelect',
    inheritAttrs: false,

    components: { FormInputContainer },

    props: {
        value: { type: [String, Number] },
        label: { type: String },
        nullable: { type: Boolean },
        errors: { type: Array },
        required: { type: Boolean, default: false },
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';
select {
    @extend %form-control;
    padding: 0 10px;
}
</style>
